import { Component, OnInit } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { Router } from '@angular/router';

@Component({
	selector: 'app-discard-modal',
	templateUrl: './discard-modal.component.html',
	styleUrls: ['./discard-modal.component.scss']
})
export class DiscardModalComponent extends AbstractModalContentComponent implements OnInit {

	constructor(
		protected modalService: ModalService,
		private router: Router
	) {
		super(modalService);
		this.TYPE = 'dialog';
	}

	ngOnInit() {
	}

	cancel() {
		this.closeModal();
		this.data[0].handleClose(false, false);
		// window.scrollTo(0, 0);
	}

	discard() {
		this.closeModal();

		if (this.data && this.data[0] && this.data[0].handleClose) {
			this.data[0].handleClose(false, true);
		}
	}

}
